import StatusAvatar from 'components/shared/AgentStatusAvatar'
import React, { Component } from 'react'
import Moment from 'moment'
import './style'


const DEFAULT_MAX_USERS = 10

class UserHeader extends Component {

  constructor(props) {
    super(props)

    this.state = {
      MAX_USERS: props.MAX_USERS || DEFAULT_MAX_USERS,
      isMultiUser: props.users.length > 1,
      firstUser: props.users[0]
    }
  }

  renderMultiUsers = () =>{
    const { MAX_USERS } = this.state
    const classes = ['user-header-info', 'multi-user']

    if (this.props.leaveSpaceOnTheRight)
      classes.push('be-tiny')

    return (
      <section className={classes.join(' ')}>
        {
          this.props.users.map((user, index) => {
            const shouldEmail = user.name ? user.email : ''
            if (index < MAX_USERS)
              return (
                <span key={user.id}>
                  <span is tooltip={shouldEmail}>
                    <StatusAvatar user={user} />
                  </span>
                </span>
              )
            if (index === MAX_USERS + 1)
              return (<span className="multi-user-rest-msg">... and {this.props.users.length - index} more</span>)
          })
        }
      </section>
    )
  }

  renderSingleUser = () => {
    const { modalView, onClose } = this.props
    const { firstUser } = this.state
    const userTitle = firstUser.name || firstUser.email

    return (
      <section className="user-header-info single-user">
        <StatusAvatar user={firstUser} />

        <div className="team-user-info">
          <strong className="user-title" title={userTitle}>
            {userTitle} {this.isOwner()}
          </strong>
          {firstUser.name && firstUser.email && <small>{firstUser.email}</small>}
          {firstUser.createdAt && <small>Joined: {Moment(firstUser.createdAt).format('MMMM YYYY')}</small>}
        </div>
      </section>
    )
  }

  isOwner = () => {
    const { firstUser } = this.state
    const { showAccountOwnerTransfer } = this.props

    if (firstUser.role === 'OWNER')
      return (
        <a className="account-owner-transfer-link" onClick={showAccountOwnerTransfer}>
          Account Owner 
          <span className="account-transfer-link-arrow">></span>
        </a>
      )
  }

  render() {
    const { isMultiUser } = this.state
    return isMultiUser ? this.renderMultiUsers() : this.renderSingleUser()
  }
}

export default UserHeader



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/UserHeader/index.js